import React from "react";
import { useGlobalLoader } from "../context/GlobalLoaderContext";
import "./GlobalSkeletonOverlay.css";
import spinner from "./spinner1.png"; // Ensure this path is correct

export default function GlobalSkeletonOverlay() {
  const { loading } = useGlobalLoader();
  if (!loading) return null;

  return (
    <div className="gs-overlay" aria-busy="true" aria-live="polite">
      <div className="gs-backdrop-blur" />

      <div className="gs-loader-wrap" role="status" aria-label="Loading content">
        <div className="gs-dot-orbit" aria-hidden="true">
          {Array.from({ length: 12 }).map((_, i) => (
            <span key={i} style={{ "--i": i }} />
          ))}
        </div>

        <div className="gs-favicon-core">
          <img src={spinner} alt="Loading" />
        </div>
      </div>
    </div>
  );
}